// extracted by mini-css-extract-plugin
export default {"news":"NewsList_news__FobwW","newsList":"NewsList_newsList__0XVSb"};